module.exports = __webpack_public_path__ + "static/media/2022-mobile.f249a1d5.png";